import React from "react";
import { setAdditionalClasses } from "../assets/js/utils";

function LanguageToggler({ rtl, onPress, applyClassName }) {
  return (
    <div
      className={`langauge-toggler${setAdditionalClasses(
        [applyClassName],
        [applyClassName]
      )}`}
      onClick={onPress}
    >
      {rtl ? "En" : "ع"}
    </div>
  );
}

export default LanguageToggler;
